import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@psei/ng/select';
import { EditorModule } from '@tinymce/tinymce-angular';
import { PseicFormFieldModule } from '../pseic-form-field/pseic-form-field.module';
import { PseicEditorComponent } from './pseic-editor.component';


@NgModule({
  declarations: [PseicEditorComponent],
  imports: [
    CommonModule,
    SelectModule,
    PseicFormFieldModule,
    ReactiveFormsModule,
    FlexModule,
    EditorModule
  ],
  exports: [PseicEditorComponent]
})
export class PseicEditorModule {}
